import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=65827a86&scoped=true&"
import script from "./AlertForm.vue?vue&type=script&lang=js&"
export * from "./AlertForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65827a86",
  null
  
)

export default component.exports